import "./index.styles.scss";
import SwitchButton2 from "../../../Theme/switch-button-2/switch-button-2.component";
import { useEffect, useRef, useState } from "react";
import useToggleRow from "../../../../hooks/toggle-row.hook";
import CurrentToolsTable from "./current-tools-table";
import RecommendedToolsTable from "./recommended-tools-table";
import { SecurityStackReportLoader } from "..";

const ToolsetItem = ({
  toolset,
  technologyEnum,
  getPageData = () => { },
  onAddTool = () => { },
  setTechnologyEnum = () => { },
  onActiveChange = () => { }
}) => {
  const pointRef = useRef(null);
  const { toggleRow, panelRef, refreshState } = useToggleRow({ parentId: "sec-stack-table", rowRef: pointRef, panelVisibleOut: true });

  const onRowClick = (value) => {
    setTechnologyEnum(value);
    toggleRow();
  }

  const handleActiveChange = (value) => {
    onActiveChange(toolset?.Technology_Enum, value);
  }

  useEffect(() => {
    refreshState();
  }, [
    toolset?.SecurityStackReportBuilderTool_List, 
    toolset?.SecurityStackReportRecommendedTool_List,
  ])

  return (
    <div className="toolset-item-wrapper point" ref={pointRef}>
      <div className="toolset-item" onClick={() => { onRowClick(toolset?.Technology_Enum); }}>
        <div className="toolset-item-name">{toolset?.TechnologyName}</div>
        <SwitchButton2 active={toolset?.IsActive} onChange={(v) => { handleActiveChange(v) }} />
      </div>
      <div className="panel" ref={panelRef}>
        <div className="panel-content ">
          {toolset?.SecurityStackReportBuilderTool_List?.length ? (
            <CurrentToolsTable currentTools={toolset?.SecurityStackReportBuilderTool_List} totalCost={toolset?.CurrentToolsTotal_Text} />
          ) : <></>}
          <RecommendedToolsTable
            technologyEnum={technologyEnum}
            getPageData={getPageData}
            recommendedTools={toolset?.SecurityStackReportRecommendedTool_List}
            totalSave={toolset.RecommendedToolsTotal_Text}
            coveredTechnologies={toolset.coveredTechnologies}
            isInvestment={toolset?.IsInvestment}
            onAddTool={(tool) => {
              setTechnologyEnum(toolset?.Technology_Enum);
              onAddTool(tool);
            }}
          />
        </div>
      </div>
    </div>
  )
}

const SecStackTable = ({
  tableData,
  loading = false,
  getPageData = () => { },
  forView,
  reportId,
  mspId,
  selectedMSP,
  onAddTool,
  technologyEnum,
  setTechnologyEnum = () => { },
  onActiveChange = () => { }
}) => {
  useEffect(() => {
    if (selectedMSP?.MSPId && selectedMSP?.MSPId != 0) {
      console.log('reportId ---', reportId)
      if (reportId && reportId != 0) getPageData(selectedMSP?.MSPId, reportId);
    }
  }, [selectedMSP, reportId])

  useEffect(() => {
    if (forView) {
      getPageData(mspId, reportId);
    }
  }, [forView])

  return (
    <>
      {
        !loading ?
          <div className="sec-stack-table-container">
            <div id="sec-stack-table" className="sec-stack-table">
              <div className="sec-stack-table-header">
                <h3 className="title f-grey">{tableData?.Name}</h3>
              </div>
              {tableData?.SecurityStackReport_List?.map((toolset, index) => (
                <ToolsetItem
                  technologyEnum={technologyEnum}
                  getPageData={getPageData}
                  key={`${toolset?.TechnologyName}_${index}`}
                  toolset={toolset}
                  onAddTool={onAddTool}
                  setTechnologyEnum={setTechnologyEnum}
                  onActiveChange={onActiveChange}
                />
              ))}
            </div>
          </div> : <SecurityStackReportLoader />
      }
    </>
  )
}

export default SecStackTable;